import { render, staticRenderFns } from "./LearningSequence.vue?vue&type=template&id=5f4ed8e4&scoped=true&"
import script from "./LearningSequence.vue?vue&type=script&lang=js&"
export * from "./LearningSequence.vue?vue&type=script&lang=js&"
import style0 from "./LearningSequence.vue?vue&type=style&index=0&id=5f4ed8e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4ed8e4",
  null
  
)

export default component.exports